export default __webpack_public_path__ + "ebcbe375946fb725aa7a5b242cf76024.png";